export const TEMP_BABY_GROWTH_KEY = 'temp_baby_growth'
export const BABY_GROWTH_DATA_KEY = 'baby_growth_data'
export const TEMP_BABY_VACCINATION_KEY = 'temp_baby_vaccination'
export const BABY_VACCINATION_DATA_KEY = 'baby_vaccination_data'
export const SMART_APP_CLOSED_KEY = 'smart_app_closed'
export const INSKIN_OVULATION = 'inskin_ovulation'
export const ONBOARDING_SUBSCRIPTION_COOKIE = 'onboarding_signin'
export const SERVICE_CONNECTION_PAGE_COOKIES = 'service_connection_page'
export const SERVICE_CONNECTION_LATEST_ACCESS_COOKIES = 'snp-latest-access'
